import React from "react";

import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { CloseButtonProps } from "./close-button.props";
import { withShowIf } from "../../../../with-show-if/with-show-If.component";

export const CloseButton = withShowIf((props: CloseButtonProps) => {
  return (
    <IconButton
      className="closeButton"
      aria-label="close"
      color="inherit"
      size="small"
      onClick={props.closeModal}
    >
      <CloseIcon fontSize="inherit" />
    </IconButton>
  );
});
